import { Box, Button, Flex, Spinner, Text } from '@chakra-ui/react';
import { ComponentProps } from 'react';

interface LoadingButtonProps extends ComponentProps<typeof Button> {}

/**
 * LOADING BUTTON COMPONENT
 *
 * Renders a button with a spinner and loading text when isLoading is true
 * Same as adding `loadingText` and `isLoading` props to Chakra button except won't cause
 * errors with auto-translate by wrapping any children in a <Box>
 *
 * Usage is same as Chakra <Button />
 *
 * NOTE: This component should be used anytime a loading state is required for a button
 *
 * Chakra Issue: https://github.com/chakra-ui/chakra-ui/issues/6004
 * @param param0
 * @returns
 */
export const LoadingButton = ({ loadingText, isLoading, children, ...buttonProps }: LoadingButtonProps) => {
  return (
    <Button {...buttonProps} isDisabled={buttonProps.isDisabled || isLoading}>
      {isLoading ? <LoadingState loadingText={loadingText} size={buttonProps.size || 'sm'} /> : <Box>{children}</Box>}
    </Button>
  );
};

interface LoadingStateProps {
  loadingText?: string;
  size: ComponentProps<typeof Button>['size'];
}

const LoadingState = ({ loadingText, size }: LoadingStateProps) => (
  <Flex flexDir='row' justifyContent='center' alignItems='center'>
    <Spinner data-testid='loading-btn-spinner' speed='0.65s' size={size || 'sm'} />
    {loadingText && <Text ml='2'>{loadingText}</Text>}
  </Flex>
);
